import { FETCH_MENU, FETCH_MENU_SUCCESS } from "./actionTypes";

const initialState = {
    data: {
        before: {},
        after: {}
    }
};

const menuListR = (state = initialState, action) => {
    
    switch (action.type) {
        case FETCH_MENU_SUCCESS:
            state = { ...state, data: action.payload.response };
            return state;
    }
    return state;
}

export default menuListR